import moment from "moment";
import { RewardsType } from "../../../enums";
import { getRewardByRewardType } from "./helper";

export const businessLogicRewards = (props: any) => {
  const actions = {
    firstLoginCard: {
      visible: true,
      disabled: [],
    },
    showInterestInRenewalCard: {
      visible: false,
      disabled: [],
    },
    earlyPaymentCard: {
      visible: true,
      disabled: [],
    },
    onTimePaymentCard: {
      visible: true,
      disabled: [],
    },
  };

  const rewardsData = props?.rewardsData;
  const earlyPaymentReward = getRewardByRewardType(rewardsData, RewardsType?.EARLY_PAYMENT);
  const onTimePaymentReward = getRewardByRewardType(rewardsData, RewardsType?.ON_TIME_PAYMENT);
  const showInterestInRenewalReward = getRewardByRewardType(
    rewardsData,
    RewardsType?.SHOW_INTEREST_IN_RENEWAL
  );
  const showInterestInRenewalRewardShowAt = showInterestInRenewalReward?.show_at
    ? new Date(showInterestInRenewalReward?.show_at?.split("T")[0]?.replaceAll("-", "/"))
    : null;
  const currentDate = moment().startOf("day").toDate();
  console.log("showInterestInRenewalRewardShowAt: ", showInterestInRenewalRewardShowAt);
  console.log("currentDate: ", currentDate);
  console.log(
    "compare: ",
    showInterestInRenewalRewardShowAt && showInterestInRenewalRewardShowAt <= currentDate
  );

  const firstLoginReward = getRewardByRewardType(rewardsData, RewardsType?.FIRST_LOGIN);
  if (earlyPaymentReward) {
    actions.earlyPaymentCard.visible = true;
  }
  if (onTimePaymentReward) {
    actions.onTimePaymentCard.visible = true;
  }
  if (firstLoginReward) {
    actions.firstLoginCard.visible = true;
  }
  if (showInterestInRenewalRewardShowAt && showInterestInRenewalRewardShowAt <= currentDate) {
    actions.showInterestInRenewalCard.visible = true;
  }
  return actions;
};
